import * as React from 'react';
import { Image } from "@chakra-ui/react";
import gitlLogo from "../../assets/gitl_logo.png";

export const Logo = () => {
  return (
    <Image src={gitlLogo} alt="GetintheLoop" htmlHeight="auto" htmlWidth="130" />
  );
};
